import React from "react";
import * as styles from "./PreguntasFrecuentes.module.scss";
import FaqItem from "../UI/FaqItem/FaqItem";

export const PreguntasFrecuentes = ({faqData}) => {
  return (
    <div className={styles.container}>
      <FaqItem faqData={faqData} />
    </div>
  );
};
